module.exports = __webpack_public_path__ + "static/media/html-structure.b77a1a54.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/ep15/html-structure.png
 ** module id = 212
 ** module chunks = 0
 **/